import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared';
import { NotaCardComponent } from './nota-card.component';
import { NotaCardsComponent } from './nota-cards.component';

@NgModule({
    imports: [
        SharedModule,
    ],
    declarations: [
        NotaCardsComponent,
        NotaCardComponent
    ],
    exports: [
        NotaCardsComponent
    ]
})
export class NotaCardsModule { }
